module.exports = __webpack_public_path__ + "img/img-4.3cb0ea2a.svg";